import { Box, useTheme } from '@mui/material'
import { ReactNode } from 'react'

const PageContainer = ({ children }: { children: ReactNode }) => {
	const theme = useTheme()
	return (
		<Box
			sx={{
				padding: '0 16px',
				display: 'flex',
				flexDirection: 'column',
				width: '100%',
				gap: '24px',
				fontFamily: theme.typography.fontFamily,
				paddingBottom: '200px',
			}}
		>
			{children}
		</Box>
	)
}

export default PageContainer
